import { type UseModalState } from "@clipboard-health/ui-components";
import { DeploymentEnvironmentName, environmentConfig } from "@src/appV2/environment";
import { isCapacitorPlatform, useToast } from "@src/appV2/lib";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { type WorkerShift } from "@src/appV2/Shifts/Shift/types";
import { useCallback } from "react";

export function useOnClockOut({
  shift,
  clockOutModalState,
  tooFarAwayModalState,
  inside,
  onWillOpenClockOutModal,
}: {
  shift: WorkerShift;
  clockOutModalState: UseModalState;
  tooFarAwayModalState: UseModalState;
  inside: boolean;
  onWillOpenClockOutModal?: () => void;
}): () => void {
  const { showErrorToast } = useToast();

  const isClockOutForbidden =
    !isCapacitorPlatform() &&
    environmentConfig.REACT_APP_ENVIRONMENT_NAME === DeploymentEnvironmentName.PRODUCTION;

  return useCallback(() => {
    if (isClockOutForbidden) {
      showErrorToast("Clock out is only available on the mobile app.");
      return;
    }

    logEvent(APP_V2_USER_EVENTS.TIMEKEEPING_CLOCK_OUT_TAPPED, { shiftId: shift._id });

    // Check geofence status before opening clock out modal
    if (!inside) {
      logEvent(APP_V2_USER_EVENTS.CLOCK_OUT_OUTSIDE_GEOFENCE, {
        shiftId: shift._id,
        workerId: shift.agentId,
      });
      tooFarAwayModalState.openModal();
      return;
    }

    onWillOpenClockOutModal?.();
    clockOutModalState.openModal();
  }, [
    isClockOutForbidden,
    shift._id,
    shift.agentId,
    inside,
    onWillOpenClockOutModal,
    clockOutModalState,
    showErrorToast,
    tooFarAwayModalState,
  ]);
}
